import { Typography } from "@/components/Typography"
import { useModal } from "@/shared/hooks/useModal"
import VideoDetail from "./VideoDetail"
import { useInView } from "react-intersection-observer"
import { useNavigate } from "react-router-dom"
import { STAR_URL_NAME } from "@/shared/constants/star"
import { useAuth } from "@/shared/provider/AuthProvider"
import { useAlertDialog } from "@/shared/context/AlertDialogContext"
import type { VideoContent } from "@/service/api/video"

interface Props {
  id: number
  image: string
  title: string
  date: string
  main?: boolean
  videoList?: VideoContent[]
}

const VideoItem = (props: Props) => {
  const { id, image, title, date, main, videoList } = props
  const { showAlert, closeAlert } = useAlertDialog()
  const navigate = useNavigate()
  const { userInfo } = useAuth()
  const { isOpen } = useModal()

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const handleNavigate = () => {
    if (userInfo) {
      navigate(`/${STAR_URL_NAME}/video/${id}`, {
        state: { videoList },
      })
    } else {
      showAlert({
        logo: false,
        title: "Would you like to log in?",
        actionText: "Log in",
        cancelText: "Cancel",
        onConfirm: () => navigate("/login"),
        onCancel: () => closeAlert(),
      })
    }
  }

  return (
    <>
      <button
        onClick={handleNavigate}
        className={`flex flex-col mb-4 text-start gap-2  flex-shrink-0 ${
          main ? "w-full" : "w-[80%]"
        }`}
        ref={ref}
      >
        {inView && (
          <img
            src={image}
            alt="video thumbnail"
            className="object-cover content-center h-40 rounded-xl size-full"
            loading="lazy"
          />
        )}
        <div className="flex flex-col">
          <Typography variant="body-small" className="truncate">
            {title}
          </Typography>
          <Typography variant="body-Xsmall">{date}</Typography>
        </div>
      </button>

      {isOpen.detail && <VideoDetail />}
    </>
  )
}

export default VideoItem
